import React, {Fragment} from 'react';
import FileReaderInput from './FileReaderInput';
import classNames from 'classnames';

class FileInput extends React.Component {

    focus = () => {

    }

    select = () => {

    }

    handleChange = (e, results) => {
        results.forEach(result => {
            const [e, file] = result;
            //this.props.dispatch(uploadFile(e.target.result));
            //console.log(`Successfully uploaded ${file.name}!`);
            if (this.props.saveChanges) {
                this.props.saveChanges(this.props.name, e.target.result, e);
            }
        });
    }

    render() {
        let style = {};
        if (this.props.label === false) {
            style.display = "none";
        }
        return (
            <Fragment>
                <label htmlFor={this.props.name} className="control-label" style={style}>{this.props.label}</label>
                <FileReaderInput disabled={this.props.disabled} as={this.props.as} onChange={this.handleChange}>
                    {this.props.children || <button className={classNames(this.props.className || "btn btn-default")}>{this.props.text || "Upload"}</button>}
                </FileReaderInput>
            </Fragment>
        );
    }
}

export default FileInput;